import { useContextLayout } from 'components/Layout/context';
import routePaths from 'constants/route-paths';
import React from 'react';
// import { Collapse } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { matchPath, useLocation } from 'react-router-dom';
import { getPath } from 'utils/path';
import { SubformListButton } from '../../../style';

type Props = {
  label: string;
  pathname: string;
};

const SubformList = ({ label, pathname }: Props) => {
  const history = useHistory();
  const location = useLocation();
  const { setMenuActive } = useContextLayout();

  const path = matchPath(location.pathname, {
    path: routePaths.GROUP + routePaths.RESIDENT,
  }) as { params: { residentId: string; groupId: string } };

  const params = {
    residentId: path?.params?.residentId,
    groupId: path?.params?.groupId,
  } as { groupId: string; residentId: string };

  const activeState = history.location.pathname.includes(pathname);

  const onClick = () => {
    setMenuActive('');
    history.push(
      getPath([routePaths.GROUP, routePaths.RESIDENT, pathname], {
        groupId: params.groupId,
        residentId: params.residentId,
      }),
    );
  };

  return (
    <li
      className={`menu-item ${activeState && 'menu-item-active menu-item-open'}`}
      style={{
        paddingLeft: '16px',
      }}
    >
      <SubformListButton className="menu-link my-1" onClick={() => onClick()}>
        <span className={`menu-text active`}>{label}</span>
      </SubformListButton>
    </li>
  );
};

export default SubformList;
